<template>
    <div class="w-full bg-transparent px-8 py-4 flex items-center justify-between rounded-lg shadow" data-testid="card-counter">
        <div class="w-full flex flex-row items-center justify-between" data-testid="card-body">
            <slot name="content">
                <h2 class="flex w-full justify-end text-6xl font-semibold mx-3" data-testid="card-counter-value">
                    <div v-html="result" />
                </h2>
            </slot>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WidgetExtended } from '@/types/dashboard'
import useWidgetDataWithRefreshInterval from '@/composables/useWidgetDataWithRefreshInterval'

const props = withDefaults(
    defineProps<{
        data: WidgetExtended
        editable?: boolean
    }>(),
    {
        editable: false
    }
)

const { data: widgetData } = useWidgetDataWithRefreshInterval<string, typeof props, 'data'>(props, 'data')

const result = computed(() => widgetData.value ?? '')
</script>
